module.exports = __webpack_public_path__ + "static/media/clave-web.9d0dacae.jpg";